import { useEffect, useRef } from 'react';
import Scrollbar from 'src/minimals/Scrollbar';
import { Box, Fab } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const ChatMessageListScrollbar = ({
  children,
  conversation,
  showScrollButton,
}) => {
  const scrollRef = useRef(null);
  const isFirstRender = useRef(true);
  const conversationId = useRef(null);

  const scrollMessagesToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    if (
      !showScrollButton ||
      isFirstRender.current ||
      conversationId.current !== conversation.id
    ) {
      scrollMessagesToBottom();
    }
    isFirstRender.current = false;
  }, [conversation.id, conversation.messages]);

  useEffect(() => {
    if (conversationId.current === conversation.id) return;
    conversationId.current = conversation.id;
  }, [conversation.id]);

  return (
    <Box sx={{ overflow: 'hidden', position: 'relative', flexGrow: 1 }}>
      {showScrollButton && (
        <Fab
          variant="circular"
          size="small"
          color="primary"
          onClick={scrollMessagesToBottom}
          sx={{
            position: 'absolute',
            bottom: 10,
            right: 10,
            width: 26,
            height: 26,
            minHeight: 0,
          }}
        >
          <ArrowDownwardIcon
            sx={{
              width: 18,
              height: 18,
            }}
          />
        </Fab>
      )}
      <Scrollbar
        scrollableNodeProps={{ ref: scrollRef }}
        sx={{ p: 3, height: 1 }}
      >
        {children}
      </Scrollbar>
    </Box>
  );
};

export default ChatMessageListScrollbar;
